import React from "react";
import rocket from "../../assets/img/about/rockets.png";

function OurTeamContent() {
  const teamMembers = [
    {
      name: "bryce mathew watts",
      role: "Founder & CEO",
      description:
        "From the West Coast of Canada, Bryce is an anthropologist and ethnobotanist with a deeply engrained entrepreneurial spirit. He has led Forager for the last decade and has taken it to the finals of international business competitions and represented Canada at the G20 Young Entrepreneurs’ Alliance Summit twice.",
      photo: require("../../assets/img/our-team/bryce-mathew-watts.png"),
    },
    {
      name: "anderson guerrero",
      role: "Financial Manager",
      description:
        "A proud Colombian who over the past seven years has held various accounting roles such as team lead, manager, and coordinator with multinational companies in Latin America, Europe, and Canada. Anderson is a co-founder of Forager Financial Services and has a number of international certifications.",
      photo: require("../../assets/img/our-team/anderson-guerrero.png"),
    },
    {
      name: "mila cassari",
      role: "Account Manager",
      description:
        "As a passionate marketing professional, Mila has honed her skills in marketing, media relations, and corporate communications. Specializing in compelling content that enhances a brand's reputation, she has lead projects for a variety of international companies in the tech, cultural, and nonprofit sectors.",
      photo: require("../../assets/img/our-team/mila-cassari.png"),
    },
  ];
  return (
    <section className="bg-dark-denim">
      <div className="app-forager-international-our-team with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
        <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
          <h1 className="text-white text-4xl lg:text-6xl">our team</h1>
        </div>
      </div>
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-x-16 mt-4 relative">
        <img
          src={rocket}
          alt=""
          className="hidden lg:block absolute -top-16 left-24 w-1/3 -rotate-6 xl:-rotate-3 2xl:-rotate-2 mt-8 xl:mt-4"
        />
      </div>
      <div className="container mx-auto mt-3 md:mt-16 px-4">
        <p className="max-w-4xl mx-auto mb-8 pt-4 text-white md:text-center">
          Forager International takes inspiration from the cultural
          anthropologist Wade Davis. “The world in which you were born is just
          one model of reality. Other cultures are not failed attempts at being
          you; they are unique manifestations of the human spirit.” That is why
          we actively try to build a team at all levels and within each Forager
          brand that represents as many different cultures and identities as
          possible. Through diversity, we are able to tackle even the most
          challenging of tasks because we have a deep diversity of perspectives.
        </p>
        <div className="flex justify-center flex-wrap gap-5 pb-14 lg:pb-20">
          {teamMembers.map((member) => (
            <div
              className="flex flex-col items-center gap-5 w-[22rem] px-6 py-9 rounded-lg bg-white"
              key={member.name}
            >
              <img
                src={member.photo}
                alt={member.name}
                className="w-44 aspect-square rounded-full"
              />
              <div className="text-center">
                <p className="text-xl text-navy-blue font-semibold">
                  {member.name}
                </p>
                <span>{member.role}</span>
              </div>
              <p>{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurTeamContent;
